import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import { MEDIA_QUERIES } from '../../../Variables';

const ThankyouInfo = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 15px;
  padding: 50px;
  max-width: 500px;
  cursor: pointer;
  @media ${MEDIA_QUERIES.MOBILE} {
    padding: 50px 0;
  }
  div {
    position: relative;
    bottom: 25px;
    width: 50px;
    height: 50px;
    border: 2px solid #00a79d;
    border-radius: 50%;
    svg {
      width: 50px;
      height: 50px;
      fill: #00a79d;
      padding: 10px;
    }
  }
  h1 {
    margin-bottom: 25px;
    text-align: center;
    line-height: 1.4;
  }
  p {
    text-align: center;
    line-height: 1.4;
  }
`;
const Animation = styled.span`
  position: absolute;
  top: 0;
  left: 0;
  width: 0;
  height: 5px;
  border-radius: 5px 5px 0 0;
  background-color: #00a79d;
  animation: slide 10s 1 both linear;
  @keyframes slide {
    from {
      width: 0;
    }
    to {
      width: 100%;
    }
  }
`;
const CloseInfo = styled.p`
  font-size: 12px;
`

const ThankyouForJoining = ({ userName, exitPopupHandler }) => {
  const [counter, setCounter] = useState(10);
  const { t } = useTranslation();

  useEffect(() => {
    const timer = setTimeout(() => setCounter(counter - 1), 1000);
    if(counter === 0) {
      clearTimeout(timer);
    }
  }, [counter]);

  return (
    <ThankyouInfo onClick={exitPopupHandler}>
      <Animation />
      <div>
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512">
          <path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" />
        </svg>
      </div>
        <h1>{t('join_us_popup.thankyou_title', { userName: userName })}</h1>
        <p>{t('join_us_popup.thankyou_1_p')}</p>
        <p>{t('join_us_popup.thankyou_2_p')}</p>
        <p>{t('join_us_popup.thankyou_3_p')}</p>
          {/* <CloseInfo>wait {counter} {counter > 1 ? 'seconds' : 'second'} or click on the window to close it</CloseInfo> */}
    </ThankyouInfo>
  );
};

export default ThankyouForJoining;
